import React from 'react'

export const Square = ({
  size,
  className
}: {
  size: number
  className?: string
}) => <rect className={`Square ${className}`} width={size} height={size} />
